import { Field, Select } from '../../components/ui';
import { t } from '../../i18n';
import { COUNTRIES, ORG_KINDS, type OrganizationFields, type OrgKind, timeZones } from './data';

/** Campos de una organización (alta, edición y primera organización de un tenant). */
export function OrganizationFieldset({
  idPrefix,
  value,
  onChange,
  groups,
}: {
  idPrefix: string;
  value: OrganizationFields;
  onChange: (value: OrganizationFields) => void;
  /** Grupos existentes, para sugerir. */
  groups: string[];
}) {
  const set = (patch: Partial<OrganizationFields>) => onChange({ ...value, ...patch });
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <Field id={`${idPrefix}-nombre`} label={t('plataforma.org_nombre')} required maxLength={120} value={value.name} onChange={(e) => set({ name: e.target.value })} />
      <Field
        id={`${idPrefix}-alias`}
        label={t('plataforma.org_alias')}
        maxLength={120}
        value={value.alias ?? ''}
        onChange={(e) => set({ alias: e.target.value || null })}
      />
      <Select id={`${idPrefix}-tipo`} label={t('plataforma.org_tipo')} value={value.kind} onChange={(e) => set({ kind: e.target.value as OrgKind })}>
        {ORG_KINDS.map((k) => (
          <option key={k.value} value={k.value}>
            {t(k.label)}
          </option>
        ))}
      </Select>
      <div className="space-y-1">
        <Field
          id={`${idPrefix}-grupo`}
          label={t('plataforma.org_grupo')}
          required
          maxLength={80}
          list={`${idPrefix}-grupos`}
          value={value.groupName}
          onChange={(e) => set({ groupName: e.target.value })}
        />
        <datalist id={`${idPrefix}-grupos`}>
          {groups.map((g) => (
            <option key={g} value={g} />
          ))}
        </datalist>
        <p className="text-xs text-slate-500">{t('plataforma.org_grupo_ayuda')}</p>
      </div>
      <div className="space-y-1">
        <Select id={`${idPrefix}-pais`} label={t('plataforma.org_pais')} value={value.countryCode ?? ''} onChange={(e) => set({ countryCode: e.target.value || null })}>
          <option value="">{t('plataforma.org_sin_pais')}</option>
          {value.countryCode && !COUNTRIES.some((c) => c.code === value.countryCode) && <option value={value.countryCode}>{value.countryCode}</option>}
          {COUNTRIES.map((c) => (
            <option key={c.code} value={c.code}>
              {c.name}
            </option>
          ))}
        </Select>
        <p className="text-xs text-slate-500">{t('plataforma.org_pais_ayuda')}</p>
      </div>
      <div className="space-y-1">
        <Field
          id={`${idPrefix}-zona`}
          label={t('plataforma.org_zona')}
          required
          list={`${idPrefix}-zonas`}
          value={value.timezone}
          onChange={(e) => set({ timezone: e.target.value })}
        />
        <datalist id={`${idPrefix}-zonas`}>
          {timeZones().map((z) => (
            <option key={z} value={z} />
          ))}
        </datalist>
        <p className="text-xs text-slate-500">{t('plataforma.org_zona_ayuda')}</p>
      </div>
    </div>
  );
}
